import { Injectable } from '@angular/core';

//import { HEROES } from "./app";
import { NativeStorage } from '@ionic-native/native-storage/ngx'
import { HttpClient} from "@angular/common/http";
import { Observable } from 'rxjs';
import { id } from '@swimlane/ngx-datatable';

@Injectable({
  providedIn: 'root'
})
export class ChannelService {

    //baseurl ="http://localhost:8080/api/";  //LOCAL
    baseurl="https://d3n4kss51hbrv9.cloudfront.net/api/"; //PRODUCCION
    //baseurl="https://d3kn9pwlhosg4a.cloudfront.net/api/"; //PREPRODUCCION
    
  constructor(private nativeStorage: NativeStorage, private http: HttpClient) { }

  getchannel(mytoken:string): Observable<any> {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest','Authorization': mytoken }
    return this.http.get<any>(this.baseurl+'channels',{ headers });
  }

  usuariosregistrar(data: {
    "userId": number,
    "channelId": number
  }): Observable<any>  {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    return this.http.post<any>(this.baseurl+'channels/subscribe', data, { headers });
  }

  getchannelfavorito(id: number): Observable<any> {
    const headers = { 'Accept': 'application/json',  'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    return this.http.get<any>(this.baseurl+'channels/favoritos/'+id,{ headers });
  }

}
